import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DetailedOrderItem } from '../models/virtual-store/detailed-order-item.model';
import { JsonResult } from '../core/json-result.model';
import { OrderItemInsertRequest } from '../models/virtual-store/order-item-insert-request.model';
import { OrderItemUpdateRequest } from '../models/virtual-store/order-item-update-request.model';
import { EnvironmentService } from '../core/services/environment.service';
import { OrderItemUpdateResponse } from '../models/virtual-store/order-item-update-response.model';
import { AuthService } from '../core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OrderItemService {
  controller: string = 'OrderItem';
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private authService:AuthService
    ) { }

  addPendingOne(orderItem: OrderItemInsertRequest) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/v2/Pending`;
    return this.httpClient.post<JsonResult<OrderItemUpdateResponse>>(url, orderItem);
  }

  updatePendingOne(orderItem: OrderItemUpdateRequest) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/v2/Pending`;
    return this.httpClient.patch<JsonResult<OrderItemUpdateResponse>>(url, orderItem);
  }
  removePendingOne(id: number, clientCode: string, isFnb : boolean) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/v2/Pending`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('id', id.toString());
    httpParams = httpParams.append('clientCode', clientCode);
    if(isFnb){
      httpParams = httpParams.append('isFnb', isFnb.toString());
      httpParams = httpParams.append('documentType', this.authService.getBasicData().documentType);
      httpParams = httpParams.append('documentNumber', this.authService.getBasicData().documentNumber);
    }    
    return this.httpClient.delete<JsonResult<OrderItemUpdateResponse>>(url, { params: httpParams });
  }
  listPendingOnes(clientCode: string, isFnb : boolean = false) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/Pending`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientCode', clientCode);
    httpParams= httpParams.append('isFnb', isFnb.toString());
    return this.httpClient.get<JsonResult<DetailedOrderItem[]>>(url, { params: httpParams });
  }
  list(orderId: number) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('orderId', orderId.toString());
    return this.httpClient.get<JsonResult<DetailedOrderItem[]>>(url, { params: httpParams });
  }  
}
